import { isEmpty, mergeWith } from 'lodash';

/**
 * Merges 2 objects and promote non-null values
 *
 * const obj1 = {a: null, b: "b"}
 * const obj2 = {a: "a", b: null}
 * => result: {a: "a", b: "b"}
 */
export function mergeWithValues(obj1: object, obj2: object): object {
  return mergeWith({}, obj1, obj2, (o: object, s: object) => (isEmpty(s) ? o : s));
}

/**
 * Reduce object to only key : value
 *
 * const obj = {key: "a", value: "b"}
 * => result: {a: "b"}
 */
export function getKeyValues(obj: object): object {
  return Object.values(obj).reduce(
    (obj: object, item: { key: string; value: unknown }) =>
      Object.assign(obj, { [item.key]: { ...item } }),
    {}
  );
}

export function getClassMethods(object: object): string[] {
  if (!(object instanceof Object)) {
    throw new Error('Not a class');
  }

  const ret: Set<string> = new Set<string>();

  function methods(obj: object): void {
    if (obj) {
      const ps: string[] = Object.getOwnPropertyNames(obj);

      ps.forEach((p: string) => {
        if (obj[p] instanceof Function) {
          ret.add(p);
        }
      });

      methods(Object.getPrototypeOf(obj));
    }
  }

  const literalMethods: string[] = Object.keys(object);
  literalMethods.forEach((m: string) => ret.add(m));
  methods(object.__proto__);

  return Array.from(ret);
}
